import { Link as LinkBase } from 'react-router-dom';
import styled from 'styled-components';

export const Link = styled(LinkBase)`
    color: inherit;
    text-decoration: none;
`;